import { createRouter, createWebHistory } from 'vue-router';

// import NProgress from 'nprogress';
// import moment from 'moment-timezone';

// import { G } from "@/_common";

import { main_routes } from "./routes";
import { user_routes } from "@/_routes";

// export const routesObj = {};
// main_routes.forEach(e => {
//     routesObj[e.name] = e;
// });
// user_routes.forEach(e => {
//     routesObj[e.name] = e;
// });

// export const routes = [
//     ...main_routes,
//     ...user_routes,
// ];

export const routes = Array.from(
    [...main_routes, ...user_routes]
    .reduce((m, o) => m.set(o.name, o), new Map)
    .values()
);


const router = createRouter({
    // history: createWebHistory(process.env.BASE_URL),
    // history: createWebHashHistory(),
    history: createWebHistory(),
    base: '',
    // base: process.env.BASE_URL,
    routes,
    // scrollBehavior() {
    //     return { left: 0, top: 0 }
    // },
    scrollBehavior(to, from, savedPosition) {
        // if (to.hash) {
        //     // If the route has a hash (e.g., /page#section1), scroll to the element with that ID
        //     return {
        //         el: to.hash,
        //         // Optional: add smooth scrolling if supported by the browser
        //         behavior: 'smooth',
        //     };
        // } else if (savedPosition) {
        //     // If navigating back/forward, restore the saved position
        //     return savedPosition;
        // } else {
        //     // Otherwise, scroll to the top of the new page
        //     return { left: 0, top: 0 };
        // }
        if (to.hash) {
            return { el: to.hash }
        }
        return { left: 0, top: 0 }
    }
});


// XSS filtri funksiyası
const containsXSS = (str) => {
    const xssPattern = /<script\b[^>]*>([\s\S]*?)<\/script>|on\w+\s*=/gi;
    return xssPattern.test(decodeURIComponent(str));
};

// router.beforeResolve((to, from, next) => {
//     if (to.name) {
//         NProgress.start();
//         next();
//     } else {
//         next();
//     }
// });

router.beforeEach((to, from, next) => {
    // NProgress.start();
    let hasMaliciousContent = false;

    // URL query parametrlərini yoxla (?search=<script>...)
    for (let key in to.query) {
        if (containsXSS(to.query[key])) {
            hasMaliciousContent = true;
            break;
        }
    }

    if (hasMaliciousContent) {
        // Əgər zərərli kod tapılarsa, istifadəçini error səhifəsinə yönləndir və ya parametri sil
        // alert("Təhlükəli URL daxiletməsi bloklandı!");
        next({ name: '404' }); // Və ya sadəcə next('/')
    }
    else if (from.fullPath.length > 2 && from.fullPath.slice(0, 3) != to.fullPath.slice(0, 3)) {
        let translatedPath = from.fullPath.replace(from.fullPath.slice(0, 3), to.fullPath.slice(0, 3));
        from.fullPath = translatedPath;
        from.path = translatedPath;
        from.href = translatedPath;
        next({ path: translatedPath, query: to.query, hash: to.hash, params: {lang: to.params.lang !== undefined ? to.params.lang : 'az'} });
    }
    else if (to.path == '/') {
        next({
            path: '/az',
            // force: true,
            // query: { redirect: to.fullPath },
            params: {lang: to.params.lang !== undefined ? to.params.lang : 'az'}
        });
    }
    else
        next();
});

router.afterEach(() => {
    // NProgress.done();
});


export default router;
